<footer>
  <div class="copyright">Copyright {{currentYear}}, All rights reserved.</div>
  <mat-icon class="help">help-circle</mat-icon>
</footer>
